// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2kUWS","title":"InfoRow_title__2AMrD"};